<div class="grid-container padding-bottom-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">Shipment Delivery Data</legend>
  </div>
  <form [formGroup]="shipmentDeliveryForm">
    <div class="grid-row grid-gap-0">
      <div class="grid-col-1">
        <label class="usa-label">BOL Number:</label>
      </div>
      <div class="grid-col-1">
        <label class="usa-label">{{shipmentBOLNumber}}</label>
      </div>
      <div class="grid-col-1">
        <label class="usa-label">Create Date:</label>
      </div>
      <div class="grid-cl-1">
        <label class="usa-label">{{shipmentCreateDate | date: 'MM/dd/yyyy' }}</label>
      </div>
    </div>

    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
        <div class="grid-row grid-gap-0">
          <div class="grid-col-5">
            <label class="usa-label">Required Delivery Date:</label>
          </div>
          <div class="grid-cl-1">
            <label class="usa-label">{{requiredDeliveryDate | date: 'MM/dd/yyyy' }}</label>
          </div>
        </div>
        <div class="grid-row grid-gap-0">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label">Delivery Code Exception</label>
            <select aria-label="Frt Delivery Exception Code" title="Frt Delivery Exception Code" id="frt-delivery-exception-codes" class="usa-select maxw-full" formControlName="frtDeliveryExceptionCode">
              <option [ngValue]="null" selected>Choose...</option>
              <option [ngValue]="exceptionCode.frtDeliveryExcptionsId" *ngFor="let exceptionCode of exceptionCodes">{{ exceptionCode.delivertExceptionCode }} - {{exceptionCode.deliveryExceptionDescription}}</option>
            </select>
          </div>
        </div>
        <div class="grid-row grid-gap-0">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label">Actual Delivery Date:<abbr title="required"
                                                                class="usa-hint usa-hint--required">*</abbr></label>


            <div class="grid-row grid-gap">
              <div class="grid-col-8 mobile-lg:grid-col-8 tablet:grid-col-8 desktop:grid-col-8">
                <div class="usa-date-picker usa-date-picker--initialized" data-min-date="0000-01-01">
                  <input class="usa-input usa-date-picker__internal-input" aria-labelledby="appointment-date-label"
                         aria-describedby="appointment-date-hint" aria-hidden="true" tabindex="-1" style="display: none;" >
                  <div class="usa-date-picker__wrapper">
                    <input class="usa-input usa-date-picker__external-input" formControlName="deliveryDateSelection"
                           id="appointment-date" name="appointment-date" aria-labelledby="appointment-date-label"
                           aria-describedby="appointment-date-hint" type="text" (change)="shipmentDeliveryDate($event)">
                    <button type="button" class="usa-date-picker__button tmss-datepicker-custom" aria-haspopup="true"
                            aria-label="Toggle calendar"></button>
                    <div class="usa-date-picker__calendar" role="application" hidden=""></div>
                    <div class="usa-sr-only usa-date-picker__status" role="status" aria-live="polite"></div>
                  </div>
                </div>
              </div>

              <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
                <select class="usa-select usa-combo-box__select tmss-custom-select" name="options" id="options" (change)="shipmentDeliveryTime($event)" formControlName="deliveryTimeSelection">
                  <option *ngFor="let hr of this.listHrs" [value]="hr.key">{{hr.value}}</option>
                </select>
              </div>
            </div>
            <div  *ngIf="this.dateCompareMessage!==null && this.dateCompareMessage!=='' ">
              <small class="text-danger">
                <span class="fa fa-warning"></span> {{ dateCompareMessage }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
        <div class="grid-row grid-gap-0">
          <div class="grid-col-5">
            <label class="usa-label">Required Pickup Date:</label>
          </div>
          <div class="grid-cl-1">
            <label class="usa-label">{{requiredPickupDate | date: 'MM/dd/yyyy' }}</label>
          </div>
        </div>
        <div class="grid-row grid-gap-0">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label">Pickup Code Exception</label>
            <select aria-label="Frt Pickup Exception Code" title="Frt Pickup Exception Code" id="frt-pickup-exception-codes" class="usa-select maxw-full" formControlName="frtPickupExceptionCode">
              <option [ngValue]="null" selected>Choose...</option>
              <option [ngValue]="exceptionCode.frtDeliveryExcptionsId" *ngFor="let exceptionCode of exceptionCodes">{{ exceptionCode.delivertExceptionCode }} - {{exceptionCode.deliveryExceptionDescription}}</option>
            </select>
          </div>
        </div>
        <div class="grid-row grid-gap-2">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label">Actual Pickup Date:<abbr title="required"
                                                              class="usa-hint usa-hint--required">*</abbr></label>

            <div class="grid-row grid-gap">
              <div class="grid-col-8 mobile-lg:grid-col-8 tablet:grid-col-8 desktop:grid-col-8">
                <div class="usa-date-picker usa-date-picker--initialized" data-min-date="0000-01-01">
                  <input class="usa-input usa-date-picker__internal-input" aria-labelledby="appointment-date-label"
                         aria-describedby="appointment-date-hint" aria-hidden="true" tabindex="-1" style="display: none;" >
                  <div class="usa-date-picker__wrapper">
                    <input class="usa-input usa-date-picker__external-input" formControlName="pickupDateSelection"
                           id="appointment-date" name="appointment-date" aria-labelledby="appointment-date-label"
                           aria-describedby="appointment-date-hint" type="text" (change)="shipmentPickupDate($event)">
                    <button type="button" class="usa-date-picker__button tmss-datepicker-custom" aria-haspopup="true"
                            aria-label="Toggle calendar"></button>
                    <div class="usa-date-picker__calendar" role="application" hidden=""></div>
                    <div class="usa-sr-only usa-date-picker__status" role="status" aria-live="polite"></div>
                  </div>
                </div>
              </div>

              <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
                <select class="usa-select usa-combo-box__select tmss-custom-select" name="options" id="options" (change)="shipmentPickupTime($event)" formControlName="pickupTimeSelection">
                  <option *ngFor="let hr of this.listHrs" [value]="hr.key">{{hr.value}}</option>
                </select>
              </div>
            </div>
            <div  *ngIf="this.dateCompareMessage!==null && this.dateCompareMessage!=='' ">
              <small class="text-danger">
                <span class="fa fa-warning"></span> {{ dateCompareMessage }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-row grid-gap-0">
      <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label">Additional Comments:</label>
        <textarea
          class="usa-textarea maxw-full"
          formControlName="additionalComments"
          id="shipmentDelivery_Comments"
          name="additional comments"
        ></textarea>
      </div>
    </div>

    <div class="grid-row padding-top-4">
      <button type="button" class="usa-button" (click)="saveShipmentDeliveryData()"
              [disabled]="this.shipmentDeliveryForm.invalid || dateTimeValidation">
        Save
      </button>
    </div>
  </form>
  <hr>
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
      <legend class="usa-legend usa-legend--medium" id="modal-1-heading" id="dialog-sizes-name3">
        File upload
      </legend>
    </div>
  </div>
  <div class="grid-row">
    <app-upload [businessType]="'shipment'" [isChild]="true"></app-upload>
  </div>
</div>
